import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { ButtonV2 } from '@zola/zola-ui';

import { removeTable } from '../../../../actions/SeatingChartActions';
import { RenderSubmitButton } from '../../../common/form';
import Loader from '../../../common/ui/Loader';

import './TableModal.less';

class DeleteTableModal extends React.Component {
  renderListItems = () => {
    const { table } = this.props;
    const items = [];
    const overflow = table.num_filled_seats - 11;

    for (let i = 0; i < table.num_seats; i += 1) {
      const item = table.seats[i];
      if (overflow > 1 && items.length === 11) {
        items.push(
          <div key={i} className="tableModal__item">
            <span>+ {overflow} more guests</span>
          </div>
        );
        break;
      } else if (!item.isEmpty) {
        items.push(
          <div key={i} className="tableModal__item">
            <span>{item.display_name}</span>
          </div>
        );
      }
    }

    return items;
  }

  render() {
    const { onCancel, handleSubmit, table, submitting, pristine, valid } = this.props;

    return (
      <div>
        <form onSubmit={handleSubmit} id="table-form" className="tableModal" noValidate>
          <h3 className="tableModal__header">{`Are you sure you want to delete ${table.name}?`}</h3>
          {table.num_filled_seats !== 0 && (
            <h4 className="tableModal__text">{table.name} will be permanently deleted. You&apos;ll still be able to find all your guests&apos; info in your guest list.</h4>
          )}
          <div className="tableModal__itemContainer">
            {this.renderListItems()}
          </div>
          {submitting ? <Loader /> : (
            <div className="tableModal__buttonGroup">
              <ButtonV2
                variant="secondary"
                className="tableModal__delete-form"
                onClick={() => onCancel()}
              >
                Cancel
              </ButtonV2>
              <RenderSubmitButton
                className="tableModal__saveBtn"
                pristine={pristine}
                submitting={submitting}
                valid={valid}
                value="Delete Table"
              />
            </div>
          )}
        </form>
      </div>
    );
  }
}

DeleteTableModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  table: PropTypes.shape({
    name: PropTypes.string,
    num_filled_seats: PropTypes.number,
    num_seats: PropTypes.number,
    seats: PropTypes.arrayOf(PropTypes.string),
  })
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onCancel: () => {
    ownProps.hideModalFn();
  },
  onSubmit: () => dispatch(removeTable(ownProps.table.uuid)).then(() => {
    ownProps.hideModalFn();
  })
});


export default connect(
  null,
  mapDispatchToProps
)(reduxForm({
  form: 'DeleteTableModal'
})(DeleteTableModal));



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/Modals/DeleteTable.jsx